<kdgh-loading-banner></kdgh-loading-banner>
